export const tomatoRed = {
    tomatoRed100: '#fbf9f8',
    tomatoRed200: '#fcf3f0',
    tomatoRed300: '#fde8e1',
    tomatoRed400: '#ffd5c7',
    tomatoRed500: '#ffc7b4',
    tomatoRed600: '#fabaa6',
    tomatoRed700: '#eba893',
    tomatoRed800: '#e09177',
    tomatoRed900: '#eb754f',
    tomatoRed1000: '#df6842',
    tomatoRed1100: '#c0502a',
    tomatoRed1200: '#542f23',
    tomatoRedAccentContrast: '#ffffff',
    tomatoRedAccentSurface: '#fdf3f1',
};

export const tomatoRedAlpha = {
    tomatoRed100: 'rgba(201, 99, 48, 0.02)',
    tomatoRed200: 'rgba(252, 76, 17, 0.05)',
    tomatoRed300: 'rgba(255, 192, 171, 0.33)',
    tomatoRed400: '#ffd5c7',
    tomatoRed500: '#ffc7b4',
    tomatoRed600: 'rgba(247, 61, 3, 0.35)',
    tomatoRed700: 'rgba(212, 52, 2, 0.42)',
    tomatoRed800: 'rgba(199, 50, 0, 0.53)',
    tomatoRed900: 'rgba(228, 57, 2, 0.69)',
    tomatoRed1000: 'rgba(213, 53, 2, 0.74)',
    tomatoRed1100: 'rgba(180, 46, 0, 0.84)',
    tomatoRed1200: 'rgba(57, 14, 0, 0.86)',
    tomatoRedAccentContrast: '#ffffff',
    tomatoRedAccentSurface: 'rgba(253, 241, 238, 0.8)',
};

export const tomatoRedDark = {
    tomatoRed100: '#15100e',
    tomatoRed200: '#1d1513',
    tomatoRed300: '#331c14',
    tomatoRed400: '#471e11',
    tomatoRed500: '#562617',
    tomatoRed600: '#653323',
    tomatoRed700: '#7c4432',
    tomatoRed800: '#a05740',
    tomatoRed900: '#eb754f',
    tomatoRed1000: '#de6943',
    tomatoRed1100: '#ff9a79',
    tomatoRed1200: '#f9d9cf',
    tomatoRedAccentContrast: '#ffffff',
    tomatoRedAccentSurface: '#1d1512',
};

export const tomatoRedDarkAlpha = {
    tomatoRed100: 'rgba(21, 16, 14, 0.01)',
    tomatoRed200: 'rgba(29, 21, 19, 0.04)',
    tomatoRed300: 'rgba(51, 28, 20, 0.11)',
    tomatoRed400: 'rgba(71, 30, 17, 0.18)',
    tomatoRed500: 'rgba(86, 38, 23, 0.24)',
    tomatoRed600: 'rgba(101, 51, 35, 0.31)',
    tomatoRed700: 'rgba(124, 68, 50, 0.38)',
    tomatoRed800: 'rgba(160, 87, 64, 0.45)',
    tomatoRed900: 'rgba(235, 117, 79, 0.7)',
    tomatoRed1000: 'rgba(222, 105, 67, 0.65)',
    tomatoRed1100: 'rgba(255, 154, 121, 0.83)',
    tomatoRed1200: 'rgba(249, 217, 207, 0.96)',
    tomatoRedAccentContrast: '#ffffff',
    tomatoRedAccentSurface: 'rgba(29, 21, 18, 0.5)',
};
